module.exports = __webpack_public_path__ + "static/iyzico-dashboard-api-keys-ff4f68b03e922fdb76413b7a8588ad3b.png";